import { JsonModel, Model } from './model'

export class NoteType extends Model {
    name: string

    static GENERAL = 'GENERAL'
    static ACCOUNTING = 'ACCOUNTING'
    static LEADERSHIP = 'LEADERSHIP'
    static COLLECTION = 'COLLECTION'
    static TIER2 = 'TIER2'

    constructor(json: JsonNoteType) {
        super(json)

        this.name = json.name
    }
}

export interface JsonNoteType extends JsonModel {
    name: string
}
